import actionTypes from 'modules/performance/actions/actionTypes';
import { remindersService } from 'config/api';
import { addNotification } from 'modules/shell/actions';

export const getAssociateRemindersList = () => async (dispatch) => {
  dispatch({
    type: actionTypes.ASSOCIATE_REMINDERS_LOADING,
  });

  try {
    const { data } = await remindersService.get('/reminders');

    dispatch({
      type: actionTypes.ASSOCIATE_REMINDERS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch(
      addNotification({
        id: `error-${Date.now()}`,
        message: 'Error while getting reminders data.',
        type: 'error',
      }),
    );
  }
};

export const changeReminderCompletionStatus = (id, payload) => async (dispatch) => {
  dispatch({
    type: actionTypes.ASSOCIATE_REMINDERS_LOADING,
  });

  try {
    await remindersService.put(`/reminders/${id}`, payload);

    dispatch({
      type: actionTypes.ASSOCIATE_REMINDER_UPDATE_SUCCESS,
      payload: {
        id,
        payload,
      },
    });
  } catch (error) {
    dispatch(
      addNotification({
        id: `error-${Date.now()}`,
        message: 'Error while updating reminders data.',
        type: 'error',
      }),
    );
  }
};

export const getTodayRemindersAmount = () => async (dispatch) => {
  dispatch({
    type: actionTypes.ASSOCIATE_REMINDERS_LOADING,
  });

  try {
    const { data } = await remindersService.get('/dashboard');

    dispatch({
      type: actionTypes.ASSOCIATE_REMINDERS_COUNT_SUCCESS,
      payload: data.today,
    });
  } catch (error) {
    dispatch(
      addNotification({
        id: `error-${Date.now()}`,
        message: 'Error while getting reminders data.',
        type: 'error',
      }),
    );
  }
};
